export default __webpack_public_path__ + "static/media/typeS_high_lamp.07171cd7.png";